export default {
    computed: {
        moneySettings() {
            return {
                decimal: ',',
                thousands: ' ',
                precision: 2
            }
        }
    },
    methods: {
        formatPrice(value) {
            return Number(value).toLocaleString('pl-PL', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })
        },
        unformatPrice(value) {
            if (value) return Number(value.replace(/[^0-9,-]+/g, '').replace(/[,]+/g, '.')).toFixed(2)
        }
    }
}
